module.exports = __webpack_public_path__ + "fonts/opensans-semibold.117d9877.woff2";